import { createFileRoute } from '@tanstack/react-router'
import RecordingEditPage from '@/pages/(protected)/workspaces/[workspaceId]/recordings/edit'

export const Route = createFileRoute(
  '/(protected)/workspaces/$workspaceId/recordings_/$flowId/edit'
)({
  component: RecordingEditPage,
})
